import React from 'react';
import { useMediaQuery, VStack } from '@wegroup/design-system';
import QuestionGroupWrapper from '../question-group/QuestionGroupWrapper';
import QuestionGroupHeader from '../question-group/QuestionGroupHeader';
import useCurrentGroups from '../../hooks/useCurrentGroups';
import CompanyScanContentWrapper from './CompanyScanContentWrapper';
import { useFormContext } from 'react-hook-form';
import InputComponentsConfig from '../../config/inputComponentsConfig';

const CompanyScanLayout: React.FC<React.PropsWithChildren<unknown>> = () => {
  const groups = useCurrentGroups();
  const [isLargerThan1720] = useMediaQuery('(min-width: 1720px)', {
    ssr: false,
  });

  return (
    <CompanyScanContentWrapper
      pb={isLargerThan1720 ? 'unset' : '16'}
      outerWrapperProps={{ pt: '4' }}
    >
      <VStack
        spacing="4"
        align="stretch"
        maxW="5xl"
        w="100%"
        margin="0 auto"
        data-test-id="COMPANY-SCAN_LAYOUT_QUESTION-PAGE-WRAPPER"
      >
        {groups.map((group) => {
          const methods = useFormContext();

          // First question of a group can decide to hide the title depending on config
          let showGroupTitle = true;
          if (
            InputComponentsConfig?.[group.questions[0].rules.input_type]
              ?.groupConfig?.isGroupTitleHidden
          )
            showGroupTitle = false;

          return (
            <VStack key={group.id} align="stretch" spacing="4">
              {showGroupTitle && <QuestionGroupHeader group={group} />}
              <QuestionGroupWrapper group={group} {...methods} />
            </VStack>
          );
        })}
      </VStack>
    </CompanyScanContentWrapper>
  );
};

export default CompanyScanLayout;
